<template>
  <el-menu :default-active="onRoutes"
           :default-openeds="onRouteKeys"
           class="el-menu-style"
           background-color="#124B8B"
           text-color="white"
           active-text-color="#599EEA"
           unique-opened
           router :collapse="$store.state.isCollapse" @select="handleSelect"
           :style="$store.state.isCollapse==true?'width:50px':''">
    <sub-menu v-for="item in menuList" :key="item.name" :param="item"></sub-menu>
  </el-menu>
</template>
<script>
import subMenu from "./subMenu.vue"
import MenuList from '@/assets/js/MenuConfig.js'

export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      collapse: true
    }
  },
  components: {
    subMenu,
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse;
    },
    userInfo() {
      if (this.$store.state.userInfo) {
        return JSON.parse(this.$store.state.userInfo)
      } else {
        return {}
      }
    },
    onRoutes() {
      // return this.$route.path;
      return this.onRouteKeys[this.onRouteKeys.length - 1]
    },
    onRouteKeys() {
      const getParentArray = (path, ms, kas = []) => {
        if (ms && ms.length > 0) {
          for (let k = 0, length = ms.length; k < length; k++) {
            if (path.indexOf(ms[k].href) > -1) {
              // if (path == ms[k].href) {
              kas.push(ms[k].href);
            }
            let i = kas.length;
            if (ms[k].children && ms[k].children.length > 0) {
              getParentArray(path, ms[k].children, kas);
            }
            if (i < kas.length) {
              kas.push(ms[k].href);
            }
          }
        }

        function unique5(arr) {
          var set = new Set(arr);
          return [...set];
        }

        return unique5(kas);
      }
      return getParentArray(this.$route.path, this.menuList);
    },

    menuList() {
      if (this.$store.state.userInfo) {
        let menuConfig = JSON.parse(JSON.parse(this.$store.state.userInfo).menuConfig)
        return MenuList.getRoleMenu(menuConfig)
      }
    },


  },
  mounted() {
    // let menuConfig = JSON.parse(JSON.parse(this.$store.state.userInfo).menuConfig)
    // this.menuList = MenuList.getRoleMenu(menuConfig)
  },
  created: function () {
    this.collapse = this.$store.state.isCollapse
  },
  methods: {
    handleSelect() {

    },
  },
}
</script>
<style lang="stylus" scoped>
.el-menu /deep/ .el-menu-item.is-active {
  background: #2E3B51 !important;
}

.el-menu-style {
  width: 200px;
  height 100%;
  overflow-y auto;
  overflow-x hidden
}
</style>
